module.exports = __webpack_public_path__ + "img/resumeBack.1767ff42.svg";